<template>
  <div class="article-list-molecule" :class="{ 'no-media-queries': relatedArticles }">
    <h1 v-if="heading" class="article-list-molecule__title">{{ heading }}</h1>
    <ArticleAtom v-for="(article, index) in articleInformation" :key="index" :article="article" :relatedArticle="relatedArticles" />
    <!-- <div v-if="loader" class="article-list-molecule__loader">
      <img :src="loaderSvg" alt="loader" />
    </div> -->
  </div>
</template>

<script>
import ArticleAtom from '../atoms/ArticleAtom.vue';

export default {
  props: {
    heading: {
      type: String,
    },
    articles: {
      type: Array,
      required: true,
    },
    relatedArticles: {
      type: Boolean,
    },
  },
  components: {
    ArticleAtom,
  },
  // data() {
  //   return {
  // showPosts: 3,
  // loaderSvg: require('@/assets/loader.svg'),
  // loader: false,
  // };
  // },
  computed: {
    articleInformation() {
      // const limitedArticles = this.articles.slice(0, this.showPosts);
      return this.articles.map((article) => {
        return {
          title: article.fields.title,
          image: article.fields.displayImage.fields.file.url,
          slug: article.fields.slug,
          id: article.sys.id,
          author: {
            name: article.fields.author?.fields?.name,
            title: article.fields.author?.fields?.title,
          },
        };
      });
    },
  },
  // methods: {
  //   handleScrollDown() {
  //     if (this.loader) return;
  //     const scrollHeight = document.documentElement.scrollHeight;
  //     const scrollTop = document.documentElement.scrollTop;
  //     const clientHeight = document.documentElement.clientHeight + 5;
  //     if (this.showPosts < this.articles.length) {
  //       if (scrollTop + clientHeight >= scrollHeight) {
  //         console.log('bottom');
  //         this.loader = true;
  //         setTimeout(() => {
  //           this.loader = false;
  //           this.showPosts += 2;
  //         }, 2000);
  //       }
  //     }
  //   },
  // },
  // mounted() {
  //   this.$nextTick(() => {
  //     window.addEventListener('scroll', this.handleScrollDown);
  //   });
  // },
  // beforeUnmount() {
  //   window.removeEventListener('scroll', this.handleScrollDown);
  // },
};
</script>

<style scoped>
.article-list-molecule {
  display: grid;
  gap: 40px;
  justify-content: center;
  margin-bottom: 30px;
  grid-template-columns: 1fr 1fr 1fr;
  max-width: 800px;
}
/* .article-list-molecule__loader {
  width: 100px;
  margin: auto;
  grid-column: 1/4;
} */

@media (max-width: 1025px) {
  .article-list-molecule:not(.no-media-queries) {
    grid-template-columns: 1fr 1fr;
    margin-bottom: 0px;
  }
  /* .article-list-molecule:not(.no-media-queries) .article-list-molecule__loader {
    grid-column: 1/3;
  } */
}

@media (max-width: 600px) {
  .article-list-molecule:not(.no-media-queries) {
    grid-template-columns: 1fr;
    padding: 0;
  }
  /* .article-list-molecule:not(.no-media-queries) .article-list-molecule__loader {
    grid-column: 1/2;
  } */
  .article-list-molecule__title {
    font-size: 25px;
  }
}
</style>
